import {
    FETCH_LEARNER_MODULES_FAIL,
    FETCH_LEARNER_MODULES_SUCCESS,
    SET_LEARNER_MODULES_ERROR,
    SET_LEARNER_MODULES_LOADING,
} from "../actions/learnerModulesActions";

const initialState = {
    loading: false,
    error: null,
    items: [],
};

export default function learnerModulesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LEARNER_MODULES_LOADING:
            return { ...state, loading: action.payload };

        case SET_LEARNER_MODULES_ERROR:
            return { ...state, error: action.payload };

        case FETCH_LEARNER_MODULES_SUCCESS:
            return { ...state, items: action.payload || [], error: null };

        case FETCH_LEARNER_MODULES_FAIL:
            return { ...state, error: action.payload };

        default:
            return state;
    }
}
